import type { ContactProps } from '@fhnw/types/contact';
import ContactItem from './ContactItem';
import { useVocab } from '@fhnw/components/VocabContext/useVocab';

type GroupedContacts = { [key: string]: ContactProps[] };

export function groupByFunctionRole(contact: ContactProps[]): GroupedContacts {
  return contact?.reduce<GroupedContacts>((acc, item) => {
    const role = item.functionRole;
    if (!acc[role]) {
      acc[role] = [];
    }
    acc[role].push(item);
    return acc;
  }, {});
}

const ContactSidebar = ({ content }: { content: any }) => {
  const isContactTypes = ['TeamContact', 'Contact'].includes(content['@type']);

  const phoneSuffixVocab = useVocab('collective.taxonomy.phonesuffix');
  const functionSuffixVocab = useVocab('collective.taxonomy.function');

  let relatedContacts = content['@components']?.related_contacts;
  relatedContacts = relatedContacts?.map((contact: any, index: number) => {
    const currentFunctionRole =
      content.related_contacts?.items[index]?.function;
    return { ...contact, functionRole: currentFunctionRole ?? 'contact' };
  });

  relatedContacts = groupByFunctionRole(relatedContacts);

  const totalFunctionRole = relatedContacts ? Object.keys(relatedContacts) : [];

  return isContactTypes || totalFunctionRole?.length > 0 ? (
    <div className="contact-content-sidebar-wrapper">
      {isContactTypes && (
        <h1>
          {content.name_affix1 && `${content.name_affix1} `}
          {content.title}
        </h1>
      )}

      {isContactTypes && (
        <ContactItem
          content={content}
          phoneSuffixVocab={phoneSuffixVocab}
          isContactTypes={isContactTypes}
        />
      )}
      {totalFunctionRole.map((role) => {
        return (
          <ContactItem
            key={role}
            content={relatedContacts[role]}
            phoneSuffixVocab={phoneSuffixVocab}
            functionSuffixVocab={functionSuffixVocab}
            functionRole={role}
            relatedContacts={true}
          />
        );
      })}
    </div>
  ) : null;
};

export default ContactSidebar;
